module.exports = __webpack_public_path__ + "images/stickers/pete-ghost@2x.b48321f8a584a2a54b66.png";